import request from '@/services/interceptor.js'

export const get_progetti = (search) => {
    return request({ url: '/progetti', method: 'get', params: search ? { search } : {}, loadingBar: true })
}

export const get_progetto = (id) => {
    return request({ url: `/progetti/${id}`, method: 'get', loadingBar: true })
}

export const create_progetto = (par) => {
    return request({ url: '/progetti', method: 'post', data: par, loadingBar: true })
}

export const update_progetto = (id, par) => {
    return request({ url: `/progetti/${id}`, method: 'put', data: par, loadingBar: true })
}

export const delete_progetto = (id) => {
    return request({ url: `/progetti/${id}`, method: 'delete', loadingBar: true })
}
